module.exports = __webpack_public_path__ + "img/qrcode_4.bfa18674.png";